import { twMerge } from "tailwind-merge"

type Props = {
  name: string;
  iconUrl: string | undefined;
  unit: string;
  className?: string;
}
export const CollateralInfo: React.FC<Props> = ({ name, iconUrl, unit, className }) => {
  return(
    <div className={twMerge('flex flex-row', className)}>
      <img src={iconUrl} alt={unit} className="w-8 h-8"/>
      <div className="flex flex-col ml-3">
        <div className="text-style-item">{name}</div>
        <div className="text-style-label text-blurWhite">({unit})</div>
      </div>
    </div>
  )
}